// IE 2026 11 03 / ODOO-350449 (заказ Игоря: p223 заголовок неактивного виджета — на всю ширину шапки; p224 — «…» и продолжение по наведению, как в ячейках)
//
// p223. С 07.10 (fe.ux.widgetHeaderOverflow, utils/widgetHeaderOverflow.js) панель кнопок шапки стоит в потоке у всех виджетов, у неактивного она прозрачна до
// наведения (App.vue .WIDGET .buttons { opacity: 0 }) — но место под ней остаётся, и заголовок режется посреди шапки, справа пусто. Теперь у НЕактивного виджета
// главной области панель вынута из потока (класс .buttons-over-title: position absolute у меню ≡, непрозрачный фон) — заголовок занимает всю ширину шапки до ≡;
// при наведении панель проявляется ПОВЕРХ хвоста заголовка, ширина поля не меняется. Сколько кнопок видно — прежний замер (hdrOverflow_calc), поэтому по
// активации панель встаёт в поток с тем же набором кнопок. Активный виджет, форма «⋯», мини-режим, телефон — как раньше.
// Выключатель: window.feSettings.set('fe.ux.titleFullWidthInactive', false) или ?fe.ux.titleFullWidthInactive=false.
//
// p224. Не поместившийся заголовок — «…» в конце (text-overflow у поля в режиме чтения, класс .title-ellipsis); при наведении на поле с обрезкой —
// продолжение текста тем же помощником, что у ячеек (utils/clipOverlay.js, хвост от места обрезки); видимая часть кончается у левого края панели,
// если она лежит поверх поля (clipX). На вкладке визуализации своя плашка полного заголовка (Widget.vizTitlePlate) — там продолжения нет.
// Выключатель: window.feSettings.set('fe.ux.titleEllipsisTail', false). Счётчики — window._widgetTitleTail.stats.

export const TITLE_FULL_FLAG = 'fe.ux.titleFullWidthInactive'
export const TITLE_TAIL_FLAG = 'fe.ux.titleEllipsisTail'

export function titleFlag_on(store, flag) {
    try { return store?.setting?.(flag, true) !== false } catch (e) { return true }
}

// панель кнопок шапки — поверх хвоста заголовка (вне потока)
export function titleFull_on({ flag = true, hdrOverflow = true, active = false, mainArea = true, inForm = false, minMode = false, mobile = false } = {}) {
    return flag !== false && !!hdrOverflow && !active && !!mainArea && !inForm && !minMode && !mobile
}

// продолжение заголовка при наведении: поле обрезано и не в правке, своей плашки (вкладка визуализации) нет, не режим объяснений по Alt
export function titleTail_want({ flag = true, editing = false, plate = false, mobile = false, alt = false, scrollWidth = 0, clientWidth = 0 } = {}) {
    return flag !== false && !editing && !plate && !mobile && !alt && scrollWidth > clientWidth + 1
}

// правый край видимой части поля: левый край панели, если она лежит поверх поля; иначе null
export function titleTail_clipX(inputRect, panelRect) {
    if (!inputRect || !panelRect || !(panelRect.width > 0)) return null
    return panelRect.left > inputRect.left && panelRect.left < inputRect.right ? panelRect.left : null
}

export const stats = { over: 0, shown: 0, hidden: 0, last: null }
if (typeof window !== 'undefined') window._widgetTitleTail = { TITLE_FULL_FLAG, TITLE_TAIL_FLAG, stats }
